export default __webpack_public_path__ + "static/media/chrome-address-bar-settings-icon.60206542.svg";